// extracted by mini-css-extract-plugin
export default {"overlay":"QRCodeGenerator_overlay__SkcTc","title":"QRCodeGenerator_title__kfFZ8","div":"QRCodeGenerator_div__HVxih","alert":"QRCodeGenerator_alert__3qpY-"};